export default __webpack_public_path__ + "static/media/Dado- andando.bb225085.gif";